<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<p-fieldset>

    <ng-template pTemplate="header">{{translations.lbl_detail}} {{translations.lbl_following_up}}
        {{translations.lbl_orders_request}}</ng-template>
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="back()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN SCREEN -->
    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <!-- FORM -->
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT NUMBER ORDER-->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_number}} {{translations.lbl_order}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedSequence').value}}</span>
                        </div>


                        <!-- INPUT APPLICANT -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_applicant}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedApplicant').value}}</span>
                        </div>


                        <!-- INPUT REQUIRED -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_required}} {{translations.lbl_to}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedRequired').value}}</span>
                        </div>


                        <!-- INPUT STATUS -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_status}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedStatus').value}}</span>
                        </div>


                        <!-- INPUT COMMENTS -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span class="p-mr-2">{{translations.lbl_comments}}</span>
                            <span class="p-text-bold p-pl-4">{{globalUserDataForm.get('selectedComments').value}}</span>
                        </div>

                    </div>
                </p-panel>
            </div>


            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <!-- INPUT REQ DATE -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_date}} {{translations.lbl_order}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedReqDate').value}}</span>
                        </div>


                        <!-- INPUT SENT DATE -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_sent_date}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedSentDate').value}}</span>
                        </div>


                        <!-- INPUT SENT DATE -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_receiving_date}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedReceiveDate').value}}</span>
                        </div>


                        <!-- INPUT LANGUAGE -->

                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_language}}</span>
                            <span class="p-text-bold">{{globalUserDataForm.get('selectedLanguage').value}}</span>
                        </div>


                        <!-- INPUT FANTASMA -->

                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                            </div>
                            <div class="p-col-12 p-md-8 p-mb-4">
                            </div>
                        </div>

                    </div>
                </p-panel>
            </div>
        </div>
    </div>


    <!-- TABLE -->
    <p-table #dt1 [value]="listOrders" styleClass="p-datatable-responsive-demo" dataKey="itemId"
        [globalFilterFields]="['itemId', 'itemName', 'reqQty','appQty','sentQty','rcvQty']" responsive="true">

        <!-- [paginator]="true" [rows]="10" [showCurrentPageReport]="true" 
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}" [rowsPerPageOptions]="[10,20,50]" -->

        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <div>
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                        class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                </div>

                <div class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </div>
            </div>
        </ng-template>

        <!-- HEADER -->
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th pSortableColumn="itemId">{{translations.lbl_item}} {{translations.lbl_id}}<p-sortIcon
                        field="itemId"></p-sortIcon></th>
                <th pSortableColumn="itemName">{{translations.lbl_name}} {{translations.lbl_item}}<p-sortIcon
                        field="itemName"></p-sortIcon></th>
                <th pSortableColumn="reqQty">{{translations.lbl_quantity}} {{translations.lbl_requested}}<p-sortIcon
                        field="reqQty"></p-sortIcon></th>
                <th pSortableColumn="appQty">{{translations.lbl_quantity}} {{translations.lbl_approved}}<p-sortIcon
                        field="appQty"></p-sortIcon></th>
                <th pSortableColumn="sentQty">{{translations.lbl_total}} {{translations.lbl_sent}}<p-sortIcon
                        field="sentQty"></p-sortIcon></th>
                <th pSortableColumn="rcvQty">{{translations.lbl_total}} {{translations.lbl_received}}<p-sortIcon
                        field="rcvQty"></p-sortIcon></th>
            </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-order let-columns="columns">
            <tr>
                <td><span class="p-column-title">{{translations.lbl_item}}
                        {{translations.lbl_id}}</span>{{order.itemId}}</td>
                <td><span class="p-column-title">{{translations.lbl_name}}
                        {{translations.lbl_item}}</span>{{order.itemName}}</td>
                <td><span class="p-column-title">{{translations.lbl_quantity}}
                        {{translations.lbl_requested}}</span>{{order.reqQty}}</td>
                <td><span class="p-column-title">{{translations.lbl_quantity}}
                        {{translations.lbl_approved}}</span>{{order.appQty}}</td>
                <td><span class="p-column-title">{{translations.lbl_total}}
                        {{translations.lbl_sent}}</span>{{order.sentQty }}</td>
                <td><span class="p-column-title">{{translations.lbl_total}}
                        {{translations.lbl_received}}</span>{{order.rcvQty}}</td>
            </tr>
        </ng-template>
        <!-- SUMMARY -->
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_there_are}} {{listOrders != null ? listOrders.length : 0 }}
                {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>
</p-fieldset>